<h3 class="s1"
    [class.visually-hidden]="!isCurrent">
    {{'Card verification'|translate}}
</h3>
<div class="p-a"
     [class.visually-hidden]="!isCurrent">
    <p class="p2 col-2">{{'Please do not refresh this page, transaction still in progress'|translate}}</p>
    <div class="pos-relative center">
        <div class="fill">
            <div class="vc-outer">
                <div class="vc-inner center">
                    <i class="busy-state-animation"></i>
                </div>
            </div>
        </div>
        <div #container
             class="checkout-confirmation-iframe m-t">
        </div>
    </div>
</div>